import React from 'react';
import { Button, Dropdown } from 'semantic-ui-react';
import selectors from '../hooks/selectors';
import fetch from '../hooks/fetch';
import ThemesDropdownItems from './ThemesDropdownItems';

const ThemesDropdown = () => {
  const { readStatus, theme, themes } = selectors.useThemesDropdown();
  fetch.useFetchRibbonThemes(readStatus);

  if (themes.length <= 1) {
    return null;
  }

  return (
    <Dropdown
      className="aridhia-themes-dropdown"
      icon={null}
      trigger={(<Button icon="paint brush" size="small" />)}
      pointing="top left"
      simple
    >
      <Dropdown.Menu>
        <ThemesDropdownItems themes={themes} value={theme} />
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default ThemesDropdown;
